import { FilterSelector } from '@elementary/common-ui/components';
import { Operator } from '@elementary/common-ui/hooks/useUrlFilters';
import { RuleFormFields } from 'shared/types';
import { ControllerRenderProps, UseFormReturn } from 'react-hook-form';

type Props = {
  methods: UseFormReturn<RuleFormFields>;
  type: 'incidentFilters' | 'assetFilters';
  disabled?: boolean;
  field: ControllerRenderProps<
    RuleFormFields,
    'incidentFilters' | 'assetFilters'
  >;
  filterOptions: {
    property: string;
    propertyLabel: string;
    options: { label: string; value: string }[];
  }[];
  defaultOperators: Operator[];
};

const RuleFilterSelector = ({
  methods,
  type,
  disabled,
  field,
  filterOptions,
  defaultOperators,
}: Props) => (
  <FilterSelector
    {...field}
    filterOptions={filterOptions}
    defaultOperators={defaultOperators}
    defaultReadOnlyOperator={false}
    onChange={() => null}
    onSubmit={(val) => {
      const newFilters = methods.watch(type) || [];

      if (val.prevValue?.length) {
        const currItemIndex = newFilters.findLastIndex(
          (f: any) => f.property === val.property,
        );
        if (val.value.length) {
          newFilters[currItemIndex] = {
            ...newFilters[currItemIndex],
            values: val.value.filter((v: string) => v !== 'all'),
            operator: val.operator,
          };
        } else {
          newFilters.splice(currItemIndex, 1);
        }
      } else {
        newFilters.push({
          property: val.property,
          operator: val.operator,
          values: val.value.filter((v: string) => v !== 'all'),
        });
      }
      methods.setValue(type, newFilters, { shouldValidate: true });
    }}
    disabled={disabled}
    currentFilters={methods.watch(type)}
    resetOnClose
  />
);

export default RuleFilterSelector;
